import { Schema } from "normalizr";
import * as redux from "redux";
import { ResponseSchema } from "~/utils/ResponseSchema";
import { apiCallTypes, apiMiddlewareActionTypes } from "../Middleware/apiMiddlewareActionTypes";
import { postJson } from "./postJson";
import { runOnce } from "./runOnce";
import { saveAction } from "./saveAction";
import { updateOperation } from "./updateOperation";

export interface AdditionalParams {
    repost?: boolean;
    apiCallType?: keyof typeof apiCallTypes;
    postWithAuthToken?: boolean;
    withActionFeedback?: boolean;
    enableUnsavedChangesNotifier?: boolean;
    skipUserFriendlyDialog?: boolean;
    ignoreErrors?: boolean;
    responseSchema?: ResponseSchema;
}

export interface ApiActionTypes {
    requestType?: string;
    successType?: string;
    failureType?: string;
    userFriendlyExcType?: string;
    objectNotFoundType?: string;
}

export interface ApiActionInfo<B = any> {
    endpoint: string;
    body?: B;
    types?: ApiActionTypes;
    additionalParams?: AdditionalParams;
    formName?: string;
    schema?: Schema;
    /**
     * Might be set in addition to schema parameter.
     * In this case current entities in store will be completely replaced
     * by entities from response (by default entities just merged)
     *  NOTE: for case when there are might be empty array in response
     *        then specify this parameter to entityKey explicitly for
     *        forcing entities reducer replace entities in store, because
     *        normalize([], schema) => { entities: {}, result: [] }
     */
    reconstructEntities?: boolean | string;
    additionalData?: any;
}

export interface SimpleRequestResponse {
    Success: boolean;
}

export interface ApiAction extends ApiActionInfo, redux.Action {
    type: apiMiddlewareActionTypes.API_CALL;
}

export const api = {
    saveAction,
    /**
     * @obsolete use api.postJson instead (just renamed getAction to postJson)
     */
    getAction: postJson,
    postJson,
    updateOperation,
    /**
     * Retunrs action creator that execute specified api action only once.
     */
    runOnce,
};
